export enum PlanRateTypeEnum {
	ageBanded = 'age_banded',
	standard = 'standard',
	reimbursement = 'reimbursement',
	variable = 'variable',
}
